import React , { useState } from 'react';
import {
  Button, SimpleForm, DateInput, AutocompleteArrayInput, AutocompleteInput, SelectArrayInput, SelectInput, ReferenceArrayInput, ReferenceInput, Toolbar, useNotify,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, SaveButton, required, FormDataConsumer, BooleanInput
} from 'react-admin';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import SendReportIcon from '@material-ui/icons/Email';
import CircularProgress from '@material-ui/core/CircularProgress'
import DataTable from 'react-data-table-component';
import { fetchUtils, usePermissions } from 'react-admin';
import { AlertComponent } from './components/alerts.js';
import { NoBidChartComponent } from './components/chart.js';
import { DisclaimerComponent } from './components/disclaimer.js';
import { LegendComponent } from './components/legend.js';
import ReportScheduler from './components/ReportScheduler';

import { ExpandMore } from '@material-ui/icons';
import {Accordion, AccordionSummary, AccordionDetails, Box, Card} from "@material-ui/core";
import FilterCardTitle from './common/filters/FilterCardTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  contrast: {
    backgroundColor: theme.palette.background.paper
  }
}));

const choicesAdType = require('./components/adtypes.json');
const choicesSizes = require('./components/sizes.json');
const choicesDevices = require('./components/devices.json');
const countryChoices = require('./components/countries.json');
const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const fetch = fetchUtils.fetchJson;


const BASE_URL = window.nobid_endpoint+'/pubreports_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  let keys = Object.keys(array[0]);
  keys = keys.filter(key => (key!=='code' && key!=='adx_ad_requests' && key!=='id'));

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (key==='code' || key==='adx_ad_requests' || key==='id') return;
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function downloadCSV(array) {
  array.forEach((row, i) => {
    delete array[i].id
    delete array[i].code
  })
  dataSupport.exportData(array)
}

const choicesInterval = [
    { id: 'day', name: 'Daily' },
    { id: 'week', name: 'Weekly' },
    { id: 'month', name: 'Monthly' },
    { id: 'year', name: 'Yearly' }
];
const choicesShowAdmin = [
  { id: '', name: ' --- SUPPLY DIMENSIONS --- ', disabled: true },
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'tldomain', name: 'Domain/App' },
  { id: 'placement', name: 'Placement' },
  { id: 'sales_rep', name: 'Sales Rep' },
  { id: 'channel', name: 'Channel' },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'adsize', name: 'Ad Size' },
  { id: 'ad_type', name: 'Ad Type' },
  { id: '', name: ' --- SUPPLY METRICS --- ', disabled: true },
  { id: 'ad_requests', name: '#Ad Requests' },
  { id: 'fill_rate', name: '%Fill Rate' },
  { id: 'rpm_ad_requests', name: '$RPM Ad Requests'},
  { id: 'avg_floor_price', name: '$Avg Floor Price' },
  { id: 'match_rate', name: '%Match Rate' },
  { id: '', name: ' --- DEMAND DIMENSIONS --- ', disabled: true },
  { id: 'bidder', name: 'Bidder' },
  { id: 'campaign', name: 'Campaign' },
  { id: 'creative', name: 'Creative' },
  { id: 'umatched', name: 'User matched' },
  { id: 'bidder_type', name: 'Demand Type' },
  { id: 'advertiser', name: 'Advertiser' },
  { id: 'experiment', name: 'Experiment' },
  { id: '', name: ' --- DEMAND METRICS --- ', disabled: true },
  { id: 'revenue', name: '$Gross Revenue' },
  { id: 'spend', name: '$Spend' },
  { id: 'ad_spend', name: '$Ad Spend' },
  { id: 'profit', name: '$Profit' },
  { id: 'clicks', name: '#Clicks' },
  { id: 'conversions', name: '#Conversions' },
  { id: 'clicks_revenue', name: '$Clicks Revenue' },
  { id: 'clicks_profit', name: '$Clicks Profit' },
  { id: 'bid_requests', name: '#Bid Requests' },
  { id: 'bid_responses', name: '#Bid Responses' },
  { id: 'response_rate', name: '%Response Rate' },
  { id: 'bid_requests_rate', name: '%Requests Rate'},
  { id: 'bid_requests_impressions_ratio', name: '#Bid Requests Per Impression'},
  { id: 'win_rate', name: '%Win Rate' },
  { id: 'pub_rpm_bid_requests', name: '$RPM Bid Requests'},
  { id: 'avg_bid_price', name: '$Avg Bid Price' },
  { id: 'tech_cost', name: '$Tech Cost' },
  { id: 'cost_per_adreq', name: '$Cost Per Ad Requesters' },
  { id: 'net_profit', name: '$Net Profit' },
  // { id: '', name: ' --- CARBON METRICS --- ', disabled: true },
  // { id: 'co2_grm_emissions', name: '#CO2e (gr)' },
  // { id: 'co2_grm_emissions_pmi', name: '#CO2e PMI (gr)' },
  // { id: 'co2_grm_emissions_pmr', name: '#CO2e PMR (gr)' },
  // { id: 'net_efficient_ratio', name: '#Net Efficient Ratio' },
  // { id: 'energy_efficient_ratio', name: '#CO2e Efficient Ratio' }
]
const choicesShowPub = [
  { id: '', name: '--- DIMENSIONS ---', disabled: true },
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'tldomain', name: 'Domain/App' },
  { id: 'placement', name: 'Placement' },
  { id: 'channel', name: 'Channel' },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'adsize', name: 'Ad Size' },
  { id: 'ad_type', name: 'Ad Type' },
  { id: 'bidder_type', name: 'Demand Type' },
  { id: 'advertiser', name: 'Advertiser' },
  { id: 'experiment', name: 'Experiment' },
  { id: '', name: '--- SUPPLY METRICS ---', disabled: true },
  { id: 'ad_requests', name: '#Ad Requests' },
  { id: 'fill_rate', name: '%Fill Rate' },
  { id: 'rpm_ad_requests', name: '$RPM Ad Requests'},
  { id: 'avg_floor_price', name: '$Avg Floor Price' },
  { id: '', name: ' --- DEMAND METRICS --- ', disabled: true },
  { id: 'bid_requests', name: '#Bid Requests' },
  { id: 'bid_responses', name: '#Bid Responses' },
  { id: 'response_rate', name: '%Response Rate' },
  { id: 'bid_requests_rate', name: '%Requests Rate'},
  { id: 'bid_requests_impressions_ratio', name: '#Bid Requests Per Impression'},
  { id: 'win_rate', name: '%Win Rate' },
  { id: 'pub_rpm_bid_requests', name: '$RPM Bid Requests'},
  { id: 'avg_bid_price', name: '$Avg Bid Price' }
]
const choicesShowAdvertiser = [
  { id: 'tldomain', name: 'Domain/App' },
  { id: 'campaign', name: 'Campaign' },
  { id: 'creative', name: 'Creative' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'country', name: 'Country' },
  { id: 'channel', name: 'Channel' },
  { id: 'device', name: 'Device' },
  { id: 'adsize', name: 'Ad Size' },
  { id: 'ad_type', name: 'Ad Type' }
]
const choicesShowBidder = [
  { id: 'tldomain', name: 'Domain/App' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'adsize', name: 'Ad Size' },
  { id: 'ad_type', name: 'Ad Type' },
  { id: 'channel', name: 'Channel' }
]
const choicesShowSuperAdmin = [
  { id: '', name: ' --- TENANT DIMENSIONS --- ', disabled: true },
  { id: 'organization', name: 'Organization' },
  ...choicesShowAdmin
];

const choicesShow = (permissions) => {
  if (!permissions) return []
  if (permissions.role === 'super_admin') {
    return choicesShowSuperAdmin;
  } else if ( permissions.role==='admin' || permissions.role==='report_admin') {
    return choicesShowAdmin;
  } else if (permissions.role === 'advertiser') {
    return choicesShowAdvertiser;
  } else if (permissions.role === 'bidder') {
    return choicesShowBidder;
  } else if (permissions.role === 'publisher') {
    return choicesShowPub;
  }
}

const choicesBidderTypes = (permissions) => {
  if (['admin', 'report_admin', 'advertiser'].includes(permissions.role)) {
    return   [
      { id: 'GOOGLE_ADX', name: 'Google ADX' },
      { id: 'RTB', name: 'RTB' },
      { id: 'DIRECT', name: 'Direct' },
      { id: 'PREDICTOR', name: 'Predictor' },
      { id: 'PERFORMANCE', name: 'Performance' }
    ]
  }
  return  [
    { id: 'PROGRAMMATIC', name: 'Programmatic' },
    { id: 'DIRECT', name: 'Direct' }
  ]
}

const choicesChannel = [
  { id: 'web', name: 'WEB' },
  { id: 'app', name: 'APP' }
]
function nameBySelector (selector) {
  return (choicesShowAdmin.find(x => x.id === selector)).name;
}

// Two wordings for one column, picked by role in columnsForLegend below.
const AVG_CPM_DEFINITION_NET = 'The Average CPM is defined as 1,000 * Net Revenue / Impressions in US Dollars ($).';
const AVG_CPM_DEFINITION_GROSS = 'The Average CPM is defined as 1,000 * Ad Spend / Impressions in US Dollars ($).';
const BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true, cell: row => row.date },
  { name: 'Organization', selector: 'organization_name', sortable: true },
  { name: 'Org ID', selector: 'organization_id', sortable: true },
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: 'Site', selector: 'site_name', sortable: true },
  { name: 'Site ID', selector: 'site_id', sortable: true },
  { name: nameBySelector('tldomain'), selector: 'tldomain', sortable: true },
  { name: 'Placement', selector: 'placement_name', sortable: true },
  { name: 'Placement ID', selector: 'placement_id', sortable: true },
  { name: 'Bidder', selector: 'bidder_name', sortable: true },
  { name: nameBySelector('bidder_type'), selector: 'bidder_type', sortable: true },
  { name: 'Campaign', selector: 'campaign_name', sortable: true },
  { name: 'Campaign ID', selector: 'campaign_id', sortable: true },
  { name: 'Creative', selector: 'creative_name', sortable: true },
  { name: 'Creative ID', selector: 'creative_id', sortable: true },
  { name: nameBySelector('sales_rep'), selector: 'sales_rep', sortable: true },
  { name: '$Sales Payout', selector: 'sales_payout', sortable: true, cell: row => <span>{ utils.formatDouble(row.sales_payout) }</span>},
  { name: nameBySelector('channel'), selector: 'channel', sortable: true },
  { name: nameBySelector('country'), selector: 'country', sortable: true },
  { name: 'Advertiser', selector: 'advertiser_name', sortable: true },
  { name: nameBySelector('device'), selector: 'device', sortable: true },
  { name: nameBySelector('adsize'), selector: 'adsize', sortable: true },
  { name: nameBySelector('ad_type'), selector: 'ad_type', sortable: true },
  { name: nameBySelector('umatched'), selector: 'umatched', sortable: true, cell: row => <span>{ row.umatched === false ? 'no' : row.umatched === true ? 'yes' : '' }</span> },
  { name: 'Experiment Group', selector: 'experiment_group', sortable: true },
  { name: 'Experiment', selector: 'experiment_name', sortable: true },
  { name: 'Exp ID', selector: 'experiment_id', sortable: true },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span> },
  { name: nameBySelector('ad_requests'), selector: 'ad_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.ad_requests) }</span>, definition: 'Incoming Ad Requests, equivalent to Ad Units.' },
  { name: nameBySelector('rpm_ad_requests'), selector: 'rpm_ad_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.rpm_ad_requests) }</span>, definition: 'The Revenue Per Million Ad Requests is defined as 1,000,000 * Revenue / Ad Requests in US Dollars ($).' },
  { name: nameBySelector('bid_requests'), selector: 'bid_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests) }</span>, definition: 'Outgoing Bid Requests from NoBid servers to our Demand partners (Bidders).' },
  { name: nameBySelector('bid_responses'), selector: 'bid_responses', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_responses) }</span>, definition: 'Bid Responses as a result of Bid Requests.' },
  { name: nameBySelector('fill_rate'), selector: 'fill_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.fill_rate, '%') }</span>, definition: 'Defined as 100 * Impressions / Ad Requests.' },
  { name: nameBySelector('response_rate'), selector: 'response_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.response_rate, '%') }</span>, definition: 'Defined as 100 * Bid Responses / Bid Requests.' },
  { name: nameBySelector('bid_requests_rate'), selector: 'bid_requests_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_requests_rate, '%') }</span>, definition: 'Defined as 100 * Impressions / Bid Requests.' },
  { name: nameBySelector('bid_requests_impressions_ratio'), selector: 'bid_requests_impressions_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_requests_impressions_ratio, ' ') }</span>, definition: 'Number of Bid Requests Per Impression. Defined as Bid Requests / Impressions.' },
  { name: nameBySelector('win_rate'), selector: 'win_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.win_rate, '%') }</span>, definition: 'Defined as 100 * Impressions / Bid Responses.' },
  { name: nameBySelector('pub_rpm_bid_requests'), selector: 'pub_rpm_bid_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.pub_rpm_bid_requests) }</span>, definition: 'The Net Revenue Per Million Bid Requests is defined as 1,000,000 * Net Revenue / Bid Requests in US Dollars ($).' },
  // { name: '#CO2e (gr)', selector: 'co2_grm_emissions', sortable: true, cell: row => <span>{ utils.formatDouble(row.co2_grm_emissions, ' ') }</span>, definition: 'The CO2 Emissions (grams) is an estimation based on the Desktop Impressions, Mobile Impressions and Bid Requests.' },
  // { name: '#CO2e PMI (gr)', selector: 'co2_grm_emissions_pmi', sortable: true, cell: row => <span>{ utils.formatDouble(row.co2_grm_emissions_pmi, ' ') }</span>, definition: 'The CO2 Emissions per 1 Million Impressions (grams) is an estimation based on the Desktop Impressions, Mobile Impressions and Bid Requests.' },
  // { name: '#CO2e PMR (gr)', selector: 'co2_grm_emissions_pmr', sortable: true, cell: row => <span>{ utils.formatDouble(row.co2_grm_emissions_pmr, ' ') }</span>, definition: 'The CO2 Emissions per 100 Million Bid Requests (grams) is an estimation based on the Desktop Impressions, Mobile Impressions and Bid Requests.' },
  // { name: nameBySelector('net_efficient_ratio'), selector: 'net_efficient_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.net_efficient_ratio, ' ') }</span>, definition: `The "${nameBySelector('net_efficient_ratio')}" is defined the total traffic (Ad Requets + Bid Requets) per Impression.` },
  // { name: nameBySelector('energy_efficient_ratio'), selector: 'energy_efficient_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.energy_efficient_ratio, ' ') }</span>, definition: `The "${nameBySelector('energy_efficient_ratio')}" is an estimate of the CO2 emmissions generated based on network traffic, impressions served, device type, demand type,  impression type...` },
  { name: nameBySelector('avg_bid_price'), selector: 'avg_bid_price', sortable: true, cell: row => <span>{ utils.formatDouble(row.avg_bid_price) }</span>, definition: 'The Average bid price defined as 1,000 * Total Bid Prices / Bid Responses in US Dollars ($).' },
  { name: nameBySelector('avg_floor_price'), selector: 'avg_floor_price', sortable: true, cell: row => <span>{ utils.formatDouble(row.avg_floor_price) }</span>, definition: 'The Average floor price defined as 1,000 * Total floor Prices / Bid Requests in US Dollars ($).' },
  { name: nameBySelector('match_rate'), selector: 'match_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.match_rate, '%') }</span>, definition: 'This is the percentage matched users by number of bid requests.' },
  { name: nameBySelector('clicks'), selector: 'clicks', sortable: true, cell: row => <span>{ utils.formatLong(row.clicks) }</span>, definition: 'Total Ad Clicks are only collected for NoBid CPC Managed Demand.' },
  { name: nameBySelector('conversions'), selector: 'conversions', sortable: true, cell: row => <span>{ utils.formatLong(row.conversions) }</span>, definition: 'Conversions reported by the advertiser conversion tag. Attributed conversions are counted on the date of the CLICK that earned them, so they line up with the impression row above; conversions we could not attribute to a click are counted on the date they happened and appear under the campaign "(unattributed)".' },
  { name: nameBySelector('clicks_revenue'), selector: 'clicks_revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.clicks_revenue) }</span>, definition: 'Total Clicks Revenue based on NoBid CPC Managed Demand in US Dollars ($).' },
  { name: nameBySelector('clicks_profit'), selector: 'clicks_profit', sortable: true, cell: row => <span>{ utils.formatDouble(row.clicks_profit) }</span>, definition: 'Total Clicks Profit based on NoBid CPC Managed Demand in US Dollars ($).' },
  { name: nameBySelector('tech_cost'), selector: 'tech_cost', sortable: true, cell: row => <span>{ utils.formatDouble(row.tech_cost) }</span>, definition: 'Daily Technology Cost is collected through the AWS Cost API plus an estimation of the monthly support charges in US Dollars ($).' },
  { name: nameBySelector('cost_per_adreq'), selector: 'cost_per_adreq', sortable: true, cell: row => <span>{ utils.formatDouble(row.cost_per_adreq) }</span>, definition: 'Daily Technology Cost per 10 million Ad Request in US Dollars ($). This price should NOT fluctuate with the traffic.' },
  { name: nameBySelector('revenue'), selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Gross Revenue in US Dollars ($).' },
  { name: '$Network Revenue', selector: 'network_revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.network_revenue) }</span> },
  { name: '$Revenue', selector: 'net_revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.net_revenue) }</span>, definition: 'Publisher Net Revenue in US Dollars ($).' },
  { name: nameBySelector('profit'), selector: 'profit', sortable: true, cell: row => <span>{ utils.formatDouble(row.profit) }</span>, definition: 'Profit is the differrence between Gross Revenue and Net Revenue in US Dollars ($).' },
  { name: nameBySelector('net_profit'), selector: 'net_profit', sortable: true, cell: row => <span>{ utils.formatDouble(row.net_profit) }</span>, definition: 'Net Profit is the differrence between Gross Revenue and Net Revenue and Technology Cost in US Dollars ($).' },
  { name: nameBySelector('spend'), selector: 'spend', sortable: true, cell: row => <span>{ utils.formatDouble(row.spend) }</span>, definition: 'Spend is the total amount in US Dollars ($) that NoBid Managed Demand spent to buy inventory.'},
  { name: nameBySelector('ad_spend'), selector: 'ad_spend', sortable: true, cell: row => <span>{ utils.formatDouble(row.ad_spend) }</span>, definition: 'Ad Spend is the total amount in US Dollars ($) that NoBid Direct Demand spent.'},
  { name: '$Avg CPM', selector: 'avg_cpm', sortable: true, cell: row => <span>{Number(Number.parseFloat(row.avg_cpm).toFixed(2))}</span>, definition: AVG_CPM_DEFINITION_NET}
];

/**
 * avg_cpm is built from a DIFFERENT numerator per role in insights
 * (service/reporter/publisher_reports.js): sum(d.revenue) - the gross clearing
 * price - for the advertiser and bidder roles, and sum(d.net_revenue) for
 * everyone else. One shared sentence cannot describe both, and the net wording
 * is the wrong half for the two roles that must never be shown payout figures.
 *
 * For the advertiser the numerator is worded "Ad Spend", matching the label
 * their own report gives `revenue` (chartMetricsChoicesAdvertiser) rather than
 * introducing "Gross Revenue" as a second name for the same money.
 *
 * NOTE: this definition is not currently reachable by anyone. LegendComponent
 * renders only definitions whose selector appears in the role's choicesShow*
 * list, and those lists hold dimensions, not metrics - avg_cpm is in none of
 * them, which is also why this column's `name` is a literal instead of
 * nameBySelector(). Corrected so it is right if a metric legend is ever wired
 * up, not because a user is reading it today.
 */
function columnsForLegend (permissions) {
  const grossSide = !!permissions && ['advertiser', 'bidder'].includes(permissions.role);
  if (!grossSide) return BASE_COLUMNS;
  return BASE_COLUMNS.map(column => column.selector === 'avg_cpm'
    ? { ...column, definition: AVG_CPM_DEFINITION_GROSS }
    : column);
}

let defaultColumnSelectors = ['date', 'impressions', 'net_revenue', 'avg_cpm'];

const chartMetricsChoicesAdmin = [
	{id:'net_revenue', name:'$Revenue'},
	{id:'revenue', name:'$Gross Revenue'},
	{id:'profit', name: '$Profit' },
  {id:'impressions', name:'Impressions'},
  {id:'ad_requests', name:'Ad Requests'},
  {id:'fill_rate', name: '%Fill Rate'},
  {id:'bid_requests', name: 'Bid Requests'},
  {id:'bid_responses', name: 'Bid Responses'},
  {id:'response_rate', name: '%Response Rate' },
  {id:'bid_requests_rate', name: '%Requests Rate'},
  {id:'bid_requests_impressions_ratio', name: '#Bid Requests Per Impression'},
  {id:'win_rate', name: '%Win Rate'},
  {id:'avg_bid_price', name: '$Avg Bid Price' },
  {id:'avg_floor_price', name: '$Avg Floor Price' },
  {id:'match_rate', name: '%Match Rate' },
  {id:'spend', name: '$Spend' },
  {id:'clicks', name: 'Clicks' },
  {id:'conversions', name: 'Conversions' },
  {id:'clicks_revenue', name: '$Clicks Revenue' },
  {id:'clicks_profit', name: '$Clicks Profit' },
  {id:'tech_cost', name: '$Tech Cost'},
  {id: 'cost_per_adreq', name: '$Cost Per Ad Requesters' },
  {id:'net_profit', name: '$Net Profit' },
	{id:'avg_cpm', name: '$Avg CPM'},
  {id:'pub_rpm_bid_requests', name: '$RPM Bid Requests'},
  {id:'rpm_ad_requests', name: '$RPM Ad Requests'},
  // {id:'co2_grm_emissions', name: '#CO2e (gr)'},
  // {id:'co2_grm_emissions_pmi', name: '#CO2e PMI (gr)'},
  // {id:'co2_grm_emissions_pmr', name: '#CO2e PMR (gr)'}
  // { id: 'net_efficient_ratio', name: '#Net Efficient Ratio' },
  // { id: 'energy_efficient_ratio', name: '#CO2e Efficient Ratio' }
];
const chartMetricsChoicesPub = [
	{id:'net_revenue', name:'$Revenue'},
	{id:'impressions', name:'Impressions'},
	{id:'avg_cpm', name: '$Avg CPM'}
];
const chartMetricsChoicesAdvertiser = [
  {id:'impressions', name:'Impressions'},
  {id:'revenue', name: '$Ad Spend' },
	{id:'avg_cpm', name: '$Avg CPM'}
];
const chartMetricsChoicesBidder = [
  {id:'revenue', name:'$Revenue'},
  {id:'impressions', name:'Impressions'},
  {id:'avg_cpm', name: '$Avg CPM'}
];
const chartMetricsChoices = (permissions, showColumns = []) => {
  if (!permissions) return chartMetricsChoicesAdmin.filter(x => ['impressions', 'avg_cpm'].includes(x));
  if (permissions.role==='admin' || permissions.role==='report_admin' || permissions.role==='super_admin') {
    return chartMetricsChoicesAdmin.filter(x => ['impressions', 'avg_cpm', 'net_revenue'].concat(showColumns.map(x=>x.selector)).includes(x.id));
  } else if (permissions.role === 'advertiser') {
    return chartMetricsChoicesAdvertiser;
  } else if (permissions.role === 'bidder') {
    return chartMetricsChoicesBidder;
  } else if (permissions.role === 'publisher') {
    return chartMetricsChoicesPub;
  }
};
const chartFormatChoices = [
	{id:'line', name:'Lines'},
	{id:'spline', name:'Smoothed'},
	{id:'column', name:'Bars'},
	{id:'area', name:'Area'},
];

const dateRangeChoices = [
  { id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
  { id: 5, name: 'Last 5 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
  { id: 15, name: 'Last 15 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
  { id: 'ytd', name: 'Year to Date' },
  { id: 'yty', name: 'Year to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];

let columns = [];

const SendScheduledReportButton = (props) => {
  let [disabled, setDisabled] = useState();
  let [label, setLabel] = useState('Save & Send Report');
  let [icon, setIcon] = useState(<SendReportIcon />);
  const notify = useNotify();
  const handleClick = () => {
    if (formData.scheduler && formData.scheduler.emails) {
      setDisabled(true);
      setLabel('Processing...');
      setIcon(<CircularProgress size={20} />);
      setTimeout(() => {
        setDisabled(false);
        setLabel('Save & Send Report');
        setIcon(<SendReportIcon />);
      }, 7500);
      const url = window.nobid_endpoint + '/pubreports_send';
      const requestOptions = {headers: new Headers()}
      requestOptions.headers.set('accept', 'application/json')
      const token = localStorage.getItem('token');
      requestOptions.headers.set('Authorization', `Bearer ${token}`);
      requestOptions.method =  'POST';
      requestOptions.body = JSON.stringify(formData)
      fetch(url, requestOptions).then(({ json }) => {
        notify(json.message, { type: 'info' });
      });
    } else {
      notify('No emails to send to, please add a emails to the scheduler', { type: 'error' });
    }
  }
  return <Button label={label} disabled={disabled} onClick={handleClick} props={props} variant="contained"
    style={{marginRight: '25px', padding: '7px', width: '230px'}} color="primary" startIcon={icon}/>;
};

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    super(props);
    this.parent = props.parent;
  }

  updateChart = function(options) {
	  if (!this) return;
	  this.parent.refs.nobidChart.refreshChart(this.parent.state.data, chartMetricsChoices(this.parent.props.permissions, this.parent.state.columns), chartFormatChoices, options);
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date) r.date = r.date.substring(0, r.date.indexOf('T'))
      }

      const showList = formData.show || [];
      if (that?.parent?.props?.permissions?.role==='advertiser') {
        defaultColumnSelectors = ['date', 'impressions', 'revenue', 'avg_cpm'];
      } else if (that?.parent?.props?.permissions?.role==='bidder') {
        defaultColumnSelectors = ['date', 'impressions', 'revenue', 'avg_cpm'];
      };
      const columnSelectors = defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`, `${x}_group`]));

      that.parent.setState({
        data: json,
        saved_data:json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false});
      if (formData.metric==='net_revenue' && that?.parent?.props?.permissions?.role==='advertiser') formData.metric = 'revenue';
      if (formData.metric==='net_revenue' && that?.parent?.props?.permissions?.role==='bidder') formData.metric = 'revenue';
      that.updateChart({metric: formData.metric, format: formData.format});
    }

    formData.show = formData.show || [];
    if (formData.show.includes('sales_rep') && !formData.show.includes('publisher')) {
      formData.show.push('publisher');
    }
    if (formData.show.includes('sales_rep') && !formData.show.includes('profit')) {
      formData.show.push('profit');
    }
    if (formData.show.includes('sales_rep')) {
      formData.show.push('sales_payout');
    }
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}` +
      `${utils.formDataFieldsQueryStringFormat(
          formData,
          ['interval', 'date_range', 'start_date', 'end_date', 'organization_id', 'publisher_id', 'site_id', 'bidder_id', 'bidder_type',
          'advertiser_id', 'campaign_id', 'creative_id', 'ad_type', 'device', 'adsize', 'channel', 'country',
          'sales_rep', 'experiment_group', 'experiment_name', 'experiment_id', 'umatched',
          'publisher_id_exclude', 'site_id_exclude', 'bidder_id_exclude']
      )}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading}/>
        { this.parent.props.formType === 'edit' &&
          <SendScheduledReportButton props={this.props}/> }
        
      </Toolbar>
    )
  }
}

const PubReportTitle = ({ record }) => {
  return <span>Earnings Report {record ? `"${record.name}"` : ''}</span>;
};

const PubReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

export const PublisherEarningReportList = ({ permissions, ...props }) => (
  <List {...props} title="Earnings Reports" perPage={25} bulkActionButtons={false} filters={<PubReportFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

const hasActiveFilters = (record) => {
  const filters = ['publisher_id', 'site_id', 'bidder_id', 'country', 'adsize', 'adtype', 'device', 'channel',
    'bidder_type', 'advertiser_id', 'experiment_id']
  return record && filters.some( f => record[f] && record[f].length > 0)
}

class PubReportComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  updateChart = function(options) {
	  this.refs.nobidChart.refreshChart(this.state.data, chartMetricsChoices(this.props.permissions, this.state.columns), chartFormatChoices, options);
  }

  handleChartMetricChanged = (value) => {
	  this.updateChart({metric: value.target.value});
  }

  handleChartFormatChanged = (value) => {
	  this.updateChart({format: value.target.value});
  }
  render() {
    const { loading, data, dateRange } = this.state;
    const { permissions, formType, record } = this.props;

    return (
      <div>
        <AlertComponent />
        <Card>
          <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: 'inherit', borderRadius: '5px' }} {...this.props}>
            <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
              <FormDataConsumer>
                {({ formData }) => setFormData(formData) }
              </FormDataConsumer>
              <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' 
                disabled={loading}/>
              <div>
                <SelectInput label="Date Range" source="date_range"
                  onChange={value => this.setState({ dateRange: value.target.value })}
                  choices={dateRangeChoices}
                  defaultValue="8"
                  disabled={loading} />
                <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                  </div>
                  <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                  </div>
                </div>
              </div>
              <SelectArrayInput label="Show"
                size="small"
                source="show" 
                choices={choicesShow(permissions)}
                style={{ width: '400px', flexGrow: 1}}
                disabled={loading} />
            </div>
              
            <Accordion defaultExpanded={formType==="create"} style={{ marginBottom: '20px'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Filters" values={hasActiveFilters(record)} />
              </AccordionSummary>
              <AccordionDetails>
                <Box style={{ width: '100%' }}>
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
                    {permissions && permissions.role === 'super_admin' && <div style={{flex: 1}}>
                      <ReferenceInput
                        source="organization_id"
                        label="Organization"
                        reference="organizations"
                        basePath="organizations"
                        perPage={100}
                        sort={{ field: 'name', order: 'ASC' }}
                        allowEmpty
                        disabled={loading}>
                        <AutocompleteInput disabled={loading}
                          label="Organization"
                          optionText="name"
                          optionValue="code"
                          fullWidth/>
                      </ReferenceInput>
                    </div>
                    }
                    {permissions && !['advertiser','bidder'].includes(permissions.role) && <div style={{flex: 1}}>
                      <ReferenceArrayInput
                        source="publisher_id"
                        label="Publisher"
                        reference="publishers"
                        basePath="publishers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        disabled={loading}>
                        <AutocompleteArrayInput disabled={loading}
                          label="Publishers"
                          optionText="name"
                          optionValue="code"
                          fullWidth/>
                      </ReferenceArrayInput>
                      <BooleanInput source="publisher_id_exclude" label="Exclude Publishers" disabled={loading} style={{marginLeft: '10px', width: '55%'}}/>
                    </div>
                    }
                    {permissions && !['advertiser','bidder'].includes(permissions.role) && <div style={{flex: 1}}>
                        <ReferenceArrayInput
                          source="site_id"
                          label="Site"
                          reference="sites"
                          basePath='sites'
                          perPage={15} 
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => utils.siteFormFilter(searchText, formData)}
                          allowEmpty
                          disabled={loading}>
                          <AutocompleteArrayInput disabled={loading} label="Sites" 
                            // optionText={r => r.name && r.adunit_path && ['admin', 'report_admin', 'super_admin'].includes(permissions.role) ? `${r.name} ${r.adunit_path} (${r.code})` : r.name ? `${r.name} (${r.code})` : ''}
                            optionText={ x => utils.formatSiteName(x) }
                            optionValue="code"
                            fullWidth/>
                        </ReferenceArrayInput>
                        <BooleanInput source="site_id_exclude" label="Exclude Sites" disabled={loading} style={{marginLeft: '10px', width: '50%'}}/>
                      </div>
                    }
                  
                    {permissions && ['admin', 'report_admin', 'super_admin'].includes(permissions.role) &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="bidder_id" 
                          label="Bidder" 
                          reference="bidders"
                          basePath='bidders'
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText })}
                          allowEmpty
                          disabled={loading} >
                          <AutocompleteArrayInput label="Bidder" optionText={record => (record && record.name)?`${record.name} (${record.code})`:""}
                            optionValue="code" fullWidth/>
                        </ReferenceArrayInput>
                        <BooleanInput source="bidder_id_exclude" label="Exclude Bidders" disabled={loading} style={{marginLeft: '10px', width: '50%'}}/>
                      </div>
                    }

                    {permissions && ['admin', 'report_admin', 'advertiser'].includes(permissions.role) &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="campaign_id" 
                          label="Campaigns" 
                          reference="adcampaigns"
                          basePath="adcampaigns"
                          perPage={15} 
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText, type: 'DIRECT' })}
                          allowEmpty
                          disabled={loading}>
                          <AutocompleteArrayInput disabled={loading} label="Campaigns" 
                            optionText={record => (record && record.name)?`${record.name} (${record.code})`:''} optionValue="code" fullWidth/>
                        </ReferenceArrayInput>
                      </div>
                    }
                  
                    {permissions && ['admin', 'report_admin', 'super_admin'].includes(permissions.role) &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="creative_id" 
                          label="Creative" 
                          reference="creatives"
                          basePath="creatives"
                          perPage={15} 
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText })}
                          allowEmpty
                          disabled={loading}>
                          <AutocompleteArrayInput disabled={loading} label="Creatives" 
                            optionText={record => (record && record.name)?`${record.name} (${record.code})`:''} optionValue="code" fullWidth/>
                        </ReferenceArrayInput>
                      </div>
                    }
                  </div>
              
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Devices" 
                        source="device" 
                        choices={choicesDevices} 
                        disabled={loading}
                        fullWidth />
                    </div>

                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Ad Sizes" 
                        source="adsize" 
                        choices={choicesSizes} 
                        disabled={loading}
                        fullWidth />
                    </div>
                    
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Ad Type" 
                        source="ad_type" 
                        choices={choicesAdType}
                        disabled={loading}
                        fullWidth />
                    </div>
                  </div>

                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Countries"
                        source="country"
                        choices={countryChoices}
                        disabled={loading}
                        fullWidth/>
                    </div>

                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Channel" 
                        source="channel" 
                        choices={choicesChannel} 
                        disabled={loading}
                        fullWidth />
                    </div>

                    {permissions && !['advertiser','bidder'].includes(permissions.role) &&
                      <div style={{flex: 1}}>
                        <SelectArrayInput label="Demand Types"
                          source="bidder_type"
                          choices={choicesBidderTypes(permissions)}
                          disabled={loading}
                          fullWidth />
                      </div>
                    }
                  </div>

                  {permissions && ['admin'].includes(permissions.role) &&
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <ReferenceArrayInput
                        source="experiment_id"
                        label="Experiments"
                        reference="experiments"
                        basePath="experiments"
                        perPage={15}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        disabled={loading}
                        fullWidth>
                        <AutocompleteArrayInput disabled={loading}
                          optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                          optionValue="code"/>
                      </ReferenceArrayInput>
                    </div>
                    <div style={{flex: 1}}>
                      <ReferenceArrayInput 
                        source="advertiser_id" 
                        label="Advertisers" 
                        reference="pubreports_advertisers"
                        basePath="pubreports_advertisers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        disabled={loading}
                        fullWidth>
                        <AutocompleteArrayInput disabled={loading} 
                          optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                          optionValue="code"/>
                      </ReferenceArrayInput>
                    </div>
                  </div>
                  }
                </Box>
              </AccordionDetails>
            </Accordion>
            <ReportScheduler style={{ marginBottom: '20px'}}/>
            <div style={{ width: '100%', overflow: 'hidden'}} >
              <div style={{ float:'right' }}>
                <SelectInput label="Chart Format" 
                  source='format' 
                  choices={chartFormatChoices}
                  defaultValue={'line'}
                  onChange={this.handleChartFormatChanged} 
                  disabled={loading}
                  style={{ paddingRight: '5px' }}
                />
                <SelectInput label="Show in Chart" 
                  source='metric' 
                  choices={chartMetricsChoices(permissions, this.state.columns)}
                  defaultValue='net_revenue'
                  onChange={this.handleChartMetricChanged} 
                  disabled={loading}
                />
              </div>
            </div>
          </SimpleForm>
        </Card>
        <div style={{ height: '15px', backgroundColor: 'transparent'}} />
        <Card>
          <NoBidChartComponent ref="nobidChart" data={data}/>
        </Card>
        <div style={{ height: '15px', backgroundColor: 'transparent'}} />
        <Card>
          <DataTable
            title="Earning Report"
            theme={window.nobid_table_theme()}
            columns={this.state.columns}
            data={data}
            progressPending={loading}
            pagination
            fixedHeader
            paginationPerPage={30}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            dense
            highlightOnHover
            subHeader={!loading}
            subHeaderComponent={
              (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="text" id='search_box' label="Search" 
                  variant="outlined" 
                  style={{ margin: '5px' }} 
                  onChange={(target) => dataSupport.filterData(this)}/>
                  <CloudDownload 
                  label="Export"
                  style={{ margin: '5px' }} 
                  color="action" 
                  onClick={() => downloadCSV(this.state.data)}
                  />
                </div>
              )
            }
          />
          <DisclaimerComponent />
          <LegendComponent columns={columnsForLegend(permissions)} choices={choicesShow(permissions)}/>
        </Card>
      </div>
    )
  }
};

export const PublisherEarningReportEdit = (props) => (
  <Edit title={<PubReportTitle />}  {...props}>
    <PubReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const PublisherEarningReportCreate = (props) => (
  <Create title="Create Earning Report" {...props}>
    <PubReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
